import { Table, Tag, Space, Button, Card, Row, Col, Form, Input, Select, DatePicker, Typography } from 'antd';
import { SearchOutlined, ReloadOutlined, ExportOutlined } from '@ant-design/icons';
const { Title } = Typography;

const { RangePicker } = DatePicker;
const { Option } = Select;

const FourGOrder = () => {
  const [form] = Form.useForm();

  // 模拟数据
  const mockData = [
    {
      key: '1',
      index: 1,
      orderNo: 'C20260228090149-13-888',
      packageName: '2年优惠套餐 157',
      packageId: 'PKG_2Y_157',
      cardMerchant: '移远通信(瀚晖)',
      license: 'HKH2532611ty7...',
      iccid: '89861125208080...',
      deviceEnt: '深圳市瀚晖威视科技...',
      deviceEntId: 'ENT_DH_001',
      fourGEnt: '深圳市瀚晖威视科技...',
      fourGEntId: 'ENT_4G_001',
      status: '已支付',
      payTimeUtc: '2026-02-28 09:01:49',
      payTimeLocal: '2026-02-28 17:01:49',
      refundTime: '--',
      payChannel: '支付宝',
      payCurrency: '人民币',
      payAmount: '299',
      userId: '1600010100a8e98c'
    },
    {
      key: '2',
      index: 2,
      orderNo: 'C20260228074756-13-999',
      packageName: '2年优惠套餐 157',
      packageId: 'PKG_2Y_157',
      cardMerchant: '--',
      license: 'HKH25326ye5t2d...',
      iccid: '89861124202098...',
      deviceEnt: '深圳市瀚晖威视科技...',
      deviceEntId: 'ENT_DH_002',
      fourGEnt: '深圳市瀚晖威视科技...',
      fourGEntId: 'ENT_4G_002',
      status: '已支付',
      payTimeUtc: '2026-02-28 07:48:00',
      payTimeLocal: '2026-02-28 15:48:00',
      refundTime: '--',
      payChannel: '支付宝',
      payCurrency: '人民币',
      payAmount: '299',
      userId: '1600010100a43560'
    }
  ];

  const columns = [
    { title: '序号', dataIndex: 'index', key: 'index', width: 70, align: 'center' },
    { title: '订单编号', dataIndex: 'orderNo', key: 'orderNo', width: 220 },
    { 
      title: '套餐信息', 
      key: 'packageInfo', 
      width: 200,
      render: (_, record) => (
        <div>
          <div style={{ fontWeight: '500' }}>{record.packageName}</div>
          <div style={{ fontSize: '12px', color: '#8c8c8c' }}>ID: {record.packageId}</div>
        </div>
      )
    },
    { title: '卡商信息', dataIndex: 'cardMerchant', key: 'cardMerchant', width: 120 },
    { title: 'License', dataIndex: 'license', key: 'license', width: 180 },
    { title: 'ICCID', dataIndex: 'iccid', key: 'iccid', width: 180 },
    { 
      title: '设备企业', 
      key: 'deviceEnt', 
      width: 200,
      render: (_, record) => (
        <div>
          <div>{record.deviceEnt}</div>
          <div style={{ fontSize: '12px', color: '#8c8c8c' }}>ID: {record.deviceEntId}</div>
        </div>
      )
    },
    { 
      title: '4G卡企业', 
      key: 'fourGEnt', 
      width: 200,
      render: (_, record) => (
        <div>
          <div>{record.fourGEnt}</div>
          <div style={{ fontSize: '12px', color: '#8c8c8c' }}>ID: {record.fourGEntId}</div>
        </div>
      )
    },
    { 
      title: '订单状态', 
      dataIndex: 'status', 
      key: 'status', 
      width: 100,
      render: (status) => <Tag color={status === '已支付' ? 'green' : 'default'}>{status}</Tag>
    },
    { 
      title: '支付时间', 
      key: 'payTime', 
      width: 210,
      render: (_, record) => (
        <div>
          <div>{record.payTimeUtc} (UTC)</div>
          <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{record.payTimeLocal} (Local)</div>
        </div>
      )
    },
    { title: '退款时间', dataIndex: 'refundTime', key: 'refundTime', width: 180 },
    { title: '支付通道', dataIndex: 'payChannel', key: 'payChannel', width: 100 },
    { title: '支付币种', dataIndex: 'payCurrency', key: 'payCurrency', width: 100 },
    { title: '支付金额', dataIndex: 'payAmount', key: 'payAmount', width: 100 },
    { title: '用户ID', dataIndex: 'userId', key: 'userId', width: 180 },
  ];

  const onReset = () => {
    form.resetFields();
  };

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>4G订单管理</Title>
      </div>
      <Card style={{ marginBottom: '16px' }}>
        <Form form={form} labelCol={{ span: 0 }} wrapperCol={{ span: 24 }}>
          <Row gutter={[24, 16]}>
            <Col span={6}>
              <Form.Item name="orderNo">
                <Input placeholder="请输入订单编号" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="packageName">
                <Input placeholder="请输入套餐名称" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="iccid">
                <Input placeholder="请输入ICCID" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="status">
                <Select placeholder="订单状态" style={{ width: '100%' }}>
                  <Option value="paid">已支付</Option>
                  <Option value="refunded">已退款</Option>
                </Select>
              </Form.Item>
            </Col>

  
            
            <Col span={6}>
              <Form.Item name="userId">
                <Input placeholder="请输入用户ID" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="license">
                <Input placeholder="请输入License" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Input.Group compact style={{ display: 'flex' }}>
                <Form.Item name="deviceEntKey" noStyle initialValue="deviceEntName">
                  <Select style={{ width: '110px' }}>
                    <Option value="deviceEntName">设备企业</Option>
                    <Option value="deviceEntId">企业ID</Option>
                  </Select>
                </Form.Item>
                <Form.Item name="deviceEntValue" noStyle>
                  <Input style={{ flex: 1 }} placeholder="请输入" />
                </Form.Item>
              </Input.Group>
            </Col>
            <Col span={6}>
              <Input.Group compact style={{ display: 'flex' }}>
                <Form.Item name="fourGEntKey" noStyle initialValue="fourGEntName">
                  <Select style={{ width: '110px' }}>
                    <Option value="fourGEntName">4G卡企业</Option>
                    <Option value="fourGEntId">企业ID</Option>
                  </Select>
                </Form.Item>
                <Form.Item name="fourGEntValue" noStyle>
                  <Input style={{ flex: 1 }} placeholder="请输入" />
                </Form.Item>
              </Input.Group>
            </Col>

            <Col span={8}>
              <Form.Item name="payTime">
                <RangePicker style={{ width: '100%' }} placeholder={['支付时间开始', '支付时间结束']} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="refundTime">
                <RangePicker style={{ width: '100%' }} placeholder={['退款时间开始', '退款时间结束']} />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Space>
                <Button type="primary" icon={<SearchOutlined />}>查询</Button>
                <Button icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
                <Button type="primary" style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }} icon={<ExportOutlined />}>导出</Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Card>

      <Card>
        <Table 
          columns={columns} 
          dataSource={mockData} 
          scroll={{ x: 2200 }}
          pagination={{
            showTotal: (total) => `共 ${total} 条数据`,
            showSizeChanger: true,
            defaultPageSize: 10
          }}
        />
      </Card>
    </div>
  );
};

export default FourGOrder;
